import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-masterpass',
  templateUrl: './masterpass.component.html',
  styleUrls: ['./masterpass.component.scss']
})
export class MasterpassComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
